module.exports = __webpack_public_path__ + "static/media/AD.8faf6702.svg";